<template>
    <div>
        <progress-header />

        <div class="container mt-4">
            <div class="row">
                <form class="col-12 col-lg-9 mb-2" @submit.prevent="handleSubmit">
                    <div class="card booking-form-card shadow-sm">
                        <div class="card-header">
                            {{ $t('taxi.pages.options.header') }}
                        </div>

                        <div class="row px-4 py-3">
                            <div class="col-12" v-if="isLoading">
                                <div class="row justify-content-center p-4">
                                    <div class="spinner-border" role="status">
                                        <span class="sr-only">{{ $t('loading') }}...</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-4" v-else v-for="(options, type) in travelOptionsByType" :key="type">
                                <div class="text-lg text-blue-600 font-weight-bold mb-3">
                                    {{ findTravelOptionTypeLabel(type) }}
                                </div>

                                <div class="d-flex justify-content-between mb-2" v-for="option in options"
                                    :key="option.id"
                                >
                                    <div>
                                        <div class="font-weight-bold">
                                            {{ option.label }}
                                        </div>

                                        <div class="text-sm">
                                            {{ formatPrice(option.gross_price, travel.currency) }} / {{ $t('piece') }}
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center flex-nowrap">
                                        <font-awesome-icon icon="minus-circle" size="sm" class="cursor-pointer button-icon"
                                            @click="handleOptionDecrease(option)"
                                        />

                                        <div class="px-2 text-blue-600 font-weight-bold">
                                            {{ option.quantity }}
                                        </div>

                                        <font-awesome-icon icon="plus-circle" size="sm" class="cursor-pointer button-icon"
                                            @click="handleOptionIncrease(option)"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 mt-4 mb-2">
                                <textarea class="form-control w-100" rows="5"
                                    :placeholder="$t('taxi.pages.options.comments')"
                                    v-model="comments"
                                ></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="my-4">
                        <button type="submit" class="btn btn-primary">
                            {{ $t('next') }}
                        </button>
                    </div>
                </form>

                <div class="col-12 col-lg-3">
                    <the-cart />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { groupBy as _groupBy } from 'lodash-es';

    import TheCart from './components/Cart/TheCart';
    import ProgressHeader from './components/ProgressHeader';
    import {trackGA} from '@utilities/tracking';
    import backofficeRepository from '@repositories/BackofficeRepository';
    import backofficeMapsRepository from '@repositories/BackofficeMapsRepository';

    export default {
        components: {
            ProgressHeader,
            TheCart,
        },

        data() {
            return {
                isLoading: !this.travelOptionsByType || !this.travelOptionsByType.length,
            };
        },

        computed: {
            ...mapGetters({
                findTravelOptionTypeLabel: 'constants/findTravelOptionTypeLabel',
                travel: 'familyAirportTaxi/getTravel',
                travelOptionPrices: 'familyAirportTaxi/getTravelOptionPrices',
            }),

            comments: {
                get() {
                    return this.$store.getters['familyAirportTaxi/getTravelOptionComments'];
                },

                set(value) {
                    this.$store.dispatch('familyAirportTaxi/setTravelOptionComments', value);
                },
            },

            travelOptionsByType: function () {
                return _groupBy(this.travelOptionPrices, 'type');
            },
        },

        created() {
            trackGA('checkout_progress', {
                checkout_step: 5,
                checkout_option: window.location.pathname,
            });

            let previousOptionQuantities = [];

            if (this.travelOptionPrices) {
                this.travelOptionPrices.forEach((option) => {
                    previousOptionQuantities[option.id] = option.quantity;
                });
            }

            backofficeRepository.additionalOptions('BUSINESS_TAXI').then(( data ) => {
                this.$store.dispatch(
                    'familyAirportTaxi/setTravelOptionPrices',
                    backofficeMapsRepository.additionalOptions(data, previousOptionQuantities)
                );
                this.isLoading = false;
            });
        },

        methods: {
            handleSubmit() {
                this.$router.push({ name: 'smart-taxi.summary' });
            },

            handleOptionDecrease(option) {
                if (option.quantity === 0) {
                    return;
                }

                this.updateQuantity(option.id, -1);
            },

            handleOptionIncrease(option) {
                this.updateQuantity(option.id, 1);
            },

            updateQuantity(optionId, value) {
                const options = JSON.parse(JSON.stringify(this.travelOptionPrices));
                const option = options.find((option) => option.id === optionId);

                option.quantity += value;

                this.$store.dispatch('familyAirportTaxi/setTravelOptionPrices', options);
            },
        },
    };
</script>

<style scoped>
    @media (max-width: 992px) {
        .button-icon {
            font-size: 1.33em;
        }
    }
</style>
